import React from "react";
import "../../scss/SatStyles.scss";

const SatNavBanner: React.FC = () => {
  return (
    <>
      <div className="w-100 courses_bg Banner-section d-flex flex-column justify-content-center">
        <div className="banner-heading">
          <h3 style={{ lineHeight: "20px" }}>SAT-Practice</h3>
          <h3>and Preparation</h3>
          <p>Your Path to SAT Success Starts Here</p>
        </div>
      </div>
    </>
  );
};
export default React.memo(SatNavBanner);
